import { STEP_KEYS } from '../../../components/CreateListingPage/constants/stepKeys';

import { useMultiplexDetails } from './useMultiplexDetails';
import { useMultiplexOverview } from './useMultiplexOverview';
import { useMultiplexUnitPublished } from './useMultiplexUnitPublished';

type Params = {
  targetStepKey: string | null;
  enabled: boolean;
};

export const useMultiplexStepPrefetch = ({ targetStepKey, enabled }: Params) => {
  const isPropertyDetails = enabled && targetStepKey === STEP_KEYS.MULTIPLEX_PROPERTY_DETAILS;
  const isOverview = enabled && targetStepKey === STEP_KEYS.MULTIPLEX_OVERVIEW;
  const isListingPublished = enabled && targetStepKey === STEP_KEYS.MULTIPLEX_LISTING_PUBLISHED;

  const details = useMultiplexDetails({ enabled: isPropertyDetails });
  const overview = useMultiplexOverview({ enabled: isOverview });
  const unitPublished = useMultiplexUnitPublished({ enabled: isListingPublished });

  const activeResult = isPropertyDetails ? details : isOverview ? overview : isListingPublished ? unitPublished : null;

  const isPrefetching = activeResult ? activeResult.isFetching && !activeResult.data && !activeResult.error : false;

  return {
    isPrefetching,
    error: activeResult?.error ?? null,
  };
};
